import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CardComponent } from './components/card/card.component';
import { MomentModule } from 'ngx-moment';
import { LoaderComponent } from './components/loader/loader.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import {
  NgbTypeaheadModule,
  NgbDatepickerModule,
  NgbTooltipModule,
  NgbModalModule,
  NgbDateAdapter,
  NgbDateParserFormatter
} from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import {
  NgbDateCustomAdapter,
  NgbDateMomentParserFormatter
} from './services/date-structure.service';
import { MessageHistoryComponent } from './views/weight-balance/message-history/message-history.component';
import { StatusComponent } from './components/status/status.component';
import { HistoryModalComponent } from './views/weight-balance/history-modal/history-modal.component';
import { JumpSeatDisplayPipe } from './pipes/jump-seat-display.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        CardComponent,
        LoaderComponent,
        MessageHistoryComponent,
        StatusComponent,
        HistoryModalComponent,
        JumpSeatDisplayPipe
    ],
    imports: [
        CommonModule,
        MomentModule,
        NgxMaskDirective,
        NgxMaskPipe,
        FontAwesomeModule
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: NgbDateCustomAdapter },
        { provide: NgbDateParserFormatter, useClass: NgbDateMomentParserFormatter }
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        CardComponent,
        MomentModule,
        LoaderComponent,
        NgbTypeaheadModule,
        NgbDatepickerModule,
        NgbTooltipModule,
        NgbModalModule,
        FormsModule,
        ReactiveFormsModule,
        MessageHistoryComponent,
        StatusComponent,
        JumpSeatDisplayPipe,
        NgxMaskDirective,
        NgxMaskPipe,
        FontAwesomeModule
    ]
})
export class SharedModule {}
